export const defaultGtm = () => ({
	submit: {
		event: 'fac_button_click',
		category: 'vuejs-funil-vendas',
		action: 'click',
		label: 'Confirmar Unidade - Modal Reserva',
	},
})
